import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
// import { Element } from 'react-scroll';
import { /* TripDetail as UIKitTripDetail, */ HR, Container } from 'tmt-ui-kit';
import xss from 'xss';

// import Cover from './TripDetail/Cover';
import CoverV2 from './TripDetail/WebV5/Cover';
import Title from './TripDetail/Title';
import BookBar from './TripDetail/BookBar';
import NoSSR from '~/components/NoSSR';
import Element from '~/components/Scroll/Element';

import { actions as sessionActions } from '~/redux/reducers/session';
import { actions as wishlistActions } from '~/redux/reducers/wishlist';
import { actions as availabilityActions } from '~/redux/reducers/availability';
import { actions as tripActions } from '~/redux/reducers/trip';
// import Breadcrumbs from '~/components/Breadcrumbs/Breadcrumbs';
// import Link from '~/components/Link/Link';
// import SimilarTrips from '~/components/TripDetail/SimilarTrips';
// import CustomizeBox from '~/components/Customize/CustomizeBox';
// import CustomDetail from '~/components/TripDetail/CustomDetail';
// import MobileAction from './MobileAction';
// import RequestBook from './RequestBook';
// import LocalTable from './LocalTable';
import { getJsonLd } from '~/utils/google-structured-data';
import { convert } from '~/utils/price';
import { isMobile } from '~/utils/helpers';
import { GalleryName, getGalleryProps } from '~/utils/gallery';
import config from '~/config';
// import Reviews from '~/components/Reviews';

const CustomizeBox = dynamic(
  () => import(/* webpackChunkName: "Customize.CustomizeBox.components" */'../Customize/CustomizeBox'),
  { ssr: false, loading: () => null }
);
const SimilarTrips = dynamic(
  () => import(/* webpackChunkName: "Trips.SimilarTrips.components" */'./SimilarTrips'),
  { loading: () => null }
);
const Topic = dynamic(
  () => import(/* webpackChunkName: "Topic.Topic.components" */'../Topic/Topic'),
  { loading: () => null }
);
// const CustomDetail = dynamic(import('./CustomDetail'));
// const GalleryReview = dynamic(import('../../components/General/Gallery/GalleryReview'), { ssr: false, loading: () => null });
const Breadcrumbs = dynamic(
  () => import(/* webpackChunkName: "Breadcrumbs.Breadcrumbs.components" */'../Breadcrumbs/Breadcrumbs'),
  { loading: () => null }
);
const LocalTable = dynamic(
  () => import(/* webpackChunkName: "TripDetail.LocalTable.components" */'./LocalTable'),
  { loading: () => null }
);
const Reviews = dynamic(
  () => import(/* webpackChunkName: "Reviews.ReviewsV2.components" */'../Reviews'),
  { loading: () => null }
);
const MeetingPointsMap = dynamic(
  () => import(/* webpackChunkName: "TripDetail.MeetingPointsMap.components" */'./TripDetail/MeetingPointsMap'),
  { loading: () => null }
);

const TripAvailableDays = dynamic(
  () => import(/* webpackChunkName: "TripDetail.AvailableDays.components" */'./TripDetail/AvailableDays'),
  { loading: () => null }
);

const TripLX = dynamic(
  () => import(/* webpackChunkName: "TripDetail.LX.components" */'./TripDetail/LX'),
  { loading: () => null }
);

const TripIntro = dynamic(
  () => import(/* webpackChunkName: "TripDetail.Intro.components" */'./TripDetail/TripIntro'),
  { loading: () => null }
);

// const TripSubjects = dynamic(
//   () => import(/* webpackChunkName: "TripDetail.Subjects.components" */'./TripDetail/Subjects'),
//   { loading: () => null }
// );

const Itinerary = dynamic(
  () => import(/* webpackChunkName: "TripDetail.Itinerary.components" */'./TripDetail/WebV5/Itinerary'),
  { loading: () => null }
);

const TripCustomDetail = dynamic(
  () => import(/* webpackChunkName: "TripDetail.CustomDetail.components" */'./TripDetail/CustomDetail'),
  { loading: () => null }
);

// const TripConditions = dynamic(
//   () => import(/* webpackChunkName: "TripDetail.TripConditions.components" */'./TripDetail/TripConditions'),
//   { loading: () => null }
// );

const PriceCondition = dynamic(
  () => import(/* webpackChunkName: "TripDetail.WebV5.PriceCondition.components" */'./TripDetail/WebV5/PriceCondition'),
  { loading: () => null }
);

const ThingsToPrepare = dynamic(
  () => import(/* webpackChunkName: "TripDetail.ThingsToPrepare.components" */'./TripDetail/ThingsToPrepare'),
  { loading: () => null }
);

const MeetingPoints = dynamic(
  () => import(/* webpackChunkName: "TripDetail.MeetingPoints.components" */'./TripDetail/MeetingPoints'),
  { loading: () => null }
);

const TripCardGallery = dynamic(
  () => import(/* webpackChunkName: "TripDetail.WebV5.CardGallery.components" */'./TripDetail/WebV5/CardGallery'),
  { loading: () => null }
);

const FAQ = dynamic(
  () => import(/* webpackChunkName: "TripDetail.WhyThisTrip.components" */'./TripDetail/WebV5/FAQ'),
);

const RequestBookV2 = dynamic(
  () => import(/* webpackChunkName: "TripDetail.RequestBookV2.components" */'./RequestBookV2'),
  { loading: () => null, ssr: false }
);

const PeriodCarRentalRequestBook = dynamic(
  () => import(/* webpackChunkName: "TripDetail.RequestBookV2.PeriodCarRentalRequestBook.components" */'./RequestBookV2/PeriodCarRentalRequestBook'),
  { loading: () => null, ssr: false }
);

const TripDetailContainer = styled(Container.InnerContainer)`
  display: flex;
`;

const BookBarContainer = styled.div`
  z-index: 999;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
`;

const DesktopColumn = styled.div`
  width: 70%;
  padding-right: 16px;
  @media(max-width: 1200px) {
    width: 100%;
    padding-right: 0;
  }
`;

const BreadcrumbContainer = styled.div`
  padding-top: 20px;
`;

const CustomizeContainer = styled.div`
  padding-top: 16px;
`;

const SliderItemContainer = styled.div`
  border: 1px solid ${props => props.theme.blueGray};
  border-radius: 6px;
  box-sizing: border-box;
  @media (max-width: 700px) {
    background: ${props => props.theme.white};
    height: 100%;
    padding: 0;
    overflow-y: scroll;
  }
`;

const SliderItemTripContainer = styled.div`
  line-height: initial;
  border: 1px solid ${props => props.theme.blueGray};
  border-radius: 6px;
  box-sizing: border-box;
  @media (max-width: 700px) {
    background: ${props => props.theme.white};
    height: 100%;
    padding: 0;
    overflow-y: scroll;
  }
`;

const CalendarSlider = styled.div`
  width: 100%;
`;

const InnerCalendar = styled.div`
  width: 30%;
  min-width: 300px;
  box-sizing: border-box;
  margin-top: 20px;
  position: relative;
  display: flex;
`;

const MeetingPointContainer = styled.div`
  display: flex;
  @media(max-width: 700px) {
    flex-direction: column;
  }
`;

const MeetingPointDetail = styled.div`
  width: 45%;
  @media(max-width: 700px) {
    width: 100%;
  }
`;

const MeetingPointMap = styled.div`
  width: 55%;
  @media(max-width: 700px) {
    margin: 0 -16px;
    width: auto;
  }
`;

const goToMessenger = () => {
  window.open('https://m.me/Takemetour');
};

// const getQuantity = memoize(
//   (quantity, trip) => {
//     return quantity > trip.max_travelers
//       ? trip.max_travelers
//       : quantity;
//   },
//   (quantity, trip) => `${quantity}-${trip._id}`
// );

const enhance = connect(
  state => ({
    isLoggedIn: state.session.isLoggedIn,
    isTripLoading: state.trip.loading,
    isSessionDataLoaded: state.session.isSessionDataLoaded,
    user: state.session.user,
    isGDPR: state.app.isGDPR,
    id: state.trip.id,
    slug: state.trip.slug,
    isLoadingPricing: state.trip.isLoadingPricing,
    pricing: state.trip.pricing,
    selectedMultiTier: state.trip.selectedMultiTier,
    galleryActiveIndex: state.gallery.activeIndex,
    combinedDynamicLoaded: state.info.combinedDynamicLoaded,
    reviews: state.trip.reviews,
  }), {
    ...wishlistActions,
    ...availabilityActions,
    replyReview: tripActions.replyReview,
    voteReview: tripActions.voteReview,
    getTripPrice: tripActions.getTripPrice,
    openSignup: sessionActions.openSignup,
    setLoginSignupCallback: sessionActions.setLoginSignupCallback,
    setSessionData: sessionActions.setSessionData,
    getSessionData: sessionActions.getSessionData,
    changeSelectedMultiTier: tripActions.changeSelectedMultiTier
  }
);

class Common extends Component {
  static propTypes = {
    availability: PropTypes.object,
    url: PropTypes.object,
    trip: PropTypes.object,
    isTripLoading: PropTypes.bool,
    selectDate: PropTypes.func,
    sessionData: PropTypes.object,
    setSessionData: PropTypes.func,
    isSessionDataLoaded: PropTypes.bool,
    peerReview: PropTypes.bool,
    getTripAvailabilityV2: PropTypes.func,
    openChat: PropTypes.func,
    openPeerReview: PropTypes.func,
    requestBooking: PropTypes.func,
    onRequest: PropTypes.func,
    onRequestV2: PropTypes.func,
    onOpenGroupedModal: PropTypes.func,
    // loadAvail: PropTypes.func,
    openAndGoTo: PropTypes.func,
    openShare: PropTypes.func,
    isLoggedIn: PropTypes.bool,
    user: PropTypes.object,
    openSignup: PropTypes.func,
    setLoginSignupCallback: PropTypes.func,
    setWishlistButton: PropTypes.func,
    addWishlist: PropTypes.func,
    removeWishlist: PropTypes.func,
    loadWishlists: PropTypes.func,
    openCustomizeQty: PropTypes.func,
    isWishlisted: PropTypes.object,
    rates: PropTypes.object,
    replyReview: PropTypes.func,
    isGDPR: PropTypes.bool,
    isLoadingPricing: PropTypes.bool,
    pricing: PropTypes.object,
    getTripPrice: PropTypes.func,
    voteReview: PropTypes.func,
    selectedMultiTier: PropTypes.array,
    galleryActiveIndex: PropTypes.number,
    combinedDynamicLoaded: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.hasOpenGallery = false;
    this.stickyState = 'top';
    // this.handleScroll = this.handleScroll.bind(this);
    // this.desktopScroll = this.desktopScroll.bind(this);
    // this.mobileScroll = this.mobileScroll.bind(this);
    // this.onClosePeerReview = this.onClosePeerReview.bind(this);
    // this.loadMoreReview = this.loadMoreReview.bind(this);
    // this.handleSelectedReviewFilter = this.handleSelectedReviewFilter.bind(this);
    // this.scrollTo = this.scrollTo.bind(this);
    // this.handleClickWishlist = this.handleClickWishlist.bind(this);
    // this.activeWishlist = this.activeWishlist.bind(this);
    // this.openZopim = this.openZopim.bind(this);
    // this.onBookDataChange = this.onBookDataChange.bind(this);
    // this.onReply = this.onReply.bind(this);
    // this.onVote = this.onVote.bind(this);
    const carRentalDate = props.trip.is_unbookable_in_advance
      ? moment().add(props.trip.hours_in_advance + 24, 'hours').startOf('day')
      : moment().add(props.trip.hours_in_advance, 'hours').startOf('day');
    this.state = {
      stickyStyle: { alignSelf: 'flex-start' },
      // mounted: false,
      tabStyle: { alignSelf: 'flex-start' },
      tabType: 'default',
      showPrice: false,
      reviewShowCount: 3,
      selectedCountry: 'all',
      // hideBookBar: false,
      carRental: {
        from: carRentalDate,
        to: carRentalDate
      },
      showCoupon: props.pricing && props.pricing.bookingFee > config.firstBooking,
      customize: false,
    };
    this.lastScrollTop = 0;
  }

  async componentDidMount() {
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    // this.setState({ mounted: true }); // eslint-disable-line
    // this.mobileBookBarIntersection = new window.IntersectionObserver((entries) => {
    //   const entry = entries[0];
    //   const { intersectionRatio, isIntersecting } = entry;
    //   if (!isIntersecting) {
    //     this.setState({ hideBookBar: false });
    //   } else if (intersectionRatio === 1) {
    //     this.setState({ hideBookBar: true });
    //   } else {
    //     this.setState({ hideBookBar: false });
    //   }
    // }, {
    //   root: null,
    //   rootMargin: '0px',
    //   threshold: [0.4, 1.0]
    // });
    // this.mobileBookBarIntersection.observe(this.coverDom);
    // if sessionData loaded then load tripAvailabilities
    const { isSessionDataLoaded, trip } = this.props;
    if (isSessionDataLoaded) {
      // const monthYear = moment().format('MMMM YYYY');
      this.loadAvail(this.props);
    }
    if (trip.product_type === 'ticket') {
      const { multi_tier_prices: mtp } = trip;
      const selectedMultiTier = mtp.map((tier, idx) => ({
        ...tier,
        active: idx === 0,
        sub_tiers: tier.sub_tiers.map((subTier, subIndex) => ({
          ...subTier,
          quantity: subIndex === 0 ? 2 : 0
        }))
      }));
      this.props.changeSelectedMultiTier(selectedMultiTier);
    }
  }

  // if ComponentDidMount can't load tripAvailabilities due to unfinished sessionData load,
  // it will then load again when isSessionDataLoaded change to true
  componentWillUpdate(nextProps) {
    if (!this.props.isSessionDataLoaded && nextProps.isSessionDataLoaded) {
      this.loadAvail(nextProps);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  onChangeCustomize = (customize) => {
    this.setState({ customize });
  }

  onClosePeerReview = () => {
    this.props.openPeerReview(false);
  }

  onReply = (id, text) => {
    this.props.replyReview(id, text);
  }

  onVote = (id, vote) => {
    this.props.voteReview(this.props.trip._id, id, vote);
  }

  // onNavigateGroupedTrip = (slug) => {
  //   if (!slug) return;
  //   Router.push(
  //     {
  //       pathname: '/trip-detail',
  //       query: {
  //         slug
  //       },
  //     },
  //     `/trip/${slug}`
  //   );
  // }

  onBookDataChange = async (quantity, dateObj, status, childQuantity, noLoadPrice = false) => {
    const date = moment(dateObj).toISOString();
    if (this.props.trip.product_type === 'trip') {
      const { trip, pricing } = this.props;
      this.setState({ showCoupon: pricing ? pricing.bookingFee > config.firstBooking : false });
      const selectedOptions = trip.additional_options.find(option => option.type === 'child_price');
      const getTripPrice = noLoadPrice ? Promise.resolve() : this.props.getTripPrice({
        promo: '',
        quantity,
        trip_id: trip._id,
        ...(selectedOptions ? {
          selected_options: [{
            ...selectedOptions,
            quantity: childQuantity
          }]
        } : {})
      }, true);
      const setSessionData = this.props.setSessionData({ quantity, date }, true);
      const [prices] = await Promise.all([getTripPrice, setSessionData]);
      this.setState({ showCoupon: prices.bookingFee > config.firstBooking });
    }
    this.props.selectDate(date, { isInstant: status === 'available', isReplaceable: status === 'replaceable' });
  }

  onOpenGallery = () => {
    const { trip, galleryActiveIndex } = this.props;
    const coverImageIndex = trip.video_url ? 0 : trip.images.findIndex(img => img.image === trip.cover_image);
    const galleryProps = getGalleryProps(trip, GalleryName.DEFAULT);
    const showIndex = this.hasOpenGallery ? galleryActiveIndex : coverImageIndex;
    this.props.openAndGoTo(
      showIndex !== -1 ? showIndex : 0,
      GalleryName.DEFAULT,
      galleryProps,
    );
    this.hasOpenGallery = true;
    // if (!this.hasOpenGallery && coverImageIndex !== -1) {
    //   this.props.openAndGoTo(coverImageIndex, GalleryName.DEFAULT, galleryProps);
    //   this.hasOpenGallery = true;
    // } else {
    //   this.props.openAndGoTo(0, GalleryName.DEFAULT, galleryProps);
    // }
  }

  onOpenGalleryAndGoTo = index => {
    const { trip } = this.props;
    const galleryProps = getGalleryProps(trip, GalleryName.DEFAULT);
    this.props.openAndGoTo(index, GalleryName.DEFAULT, galleryProps);
  }

  // getQuantity = () => {
  //   return this.props.sessionData.quantity > this.props.trip.max_travelers
  //     ? this.props.trip.max_travelers
  //     : this.props.sessionData.quantity;
  // }

  getMonthYear = () => {
    return moment(this.props.sessionData.date).format('MMMM YYYY');
  }

  loadAvail = (props = this.props) => {
    const { trip, sessionData } = props;
    const monthYear = moment(sessionData.date).format('MMMM YYYY');
    props.getTripAvailabilityV2(
      monthYear,
      trip._id,
      trip.product_type === 'ticket'
        ? trip.multi_tier_prices[0].sub_tiers.map(st => st.globaltix_ticket_id)
        : []
    );
  }

  // scrollTo = (tag) => { // eslint-disable-line
  //   scroller.scrollTo(tag, {
  //     offset: -100,
  //     duration: 500,
  //     smooth: true,
  //   });
  // }

  // openChat = () => {
  //   this.props.openChat();
  //   this.props.requestBooking(
  //     'message',
  //     'desktop',
  //     this.props.trip._id,
  //     null,
  //     getQuantity(this.props.sessionData.quantity, this.props.trip)
  //   );
  // };

  loadMoreReview = () => {
    this.setState((state) => {
      let newCount = state.reviewShowCount + 3;
      if (newCount > this.props.trip.reviews.length) {
        newCount = this.props.trip.reviews.length;
      }
      return { reviewShowCount: newCount };
    });
  }

  // closeChat = () => {
  //   this.props.openChat(false);
  // };

  activeWishlist = (active) => {
    const { trip } = this.props;
    this.props.openSignup(false);
    if (active) {
      this.props.setWishlistButton(trip._id, true);
      this.props.removeWishlist(trip._id)
        .then(() => this.props.loadWishlists());
    } else {
      this.props.setWishlistButton(trip._id, false);
      this.props.addWishlist(trip._id)
        .then(() => this.props.loadWishlists());
    }
  }

  handleClickWishlist = (event, active) => {
    event.preventDefault();
    event.stopPropagation();
    if (this.props.isLoggedIn) {
      this.activeWishlist(active);
    } else {
      this.props.openSignup();
      // this.props.openLoginSignup();
      this.props.setLoginSignupCallback(() => this.activeWishlist(active));
    }
  }

  handleScroll = () => {
    this.desktopScroll();
    // this.mobileScroll();
  }

  handleSelectedReviewFilter = (country) => {
    this.setState({
      selectedCountry: country,
      reviewShowCount: 3
    });
  }

  desktopScroll = () => {
    const offset = this.props.isGDPR ? 106 : 66;
    const { top } = this.stickyContainer.getBoundingClientRect();
    const elmHeight = this.stickyElement.offsetHeight;
    const contHeight = this.stickyContainer.offsetHeight;
    if (top >= offset) {
      if (this.stickyState === 'top') return;
      this.stickyElement.style.position = 'initial';
      this.stickyElement.style.top = 0;
      this.stickyElement.style.alignSelf = 'flex-start';
      this.stickyState = 'top';
      // this.setState({
      // stickyState: 'top',
      // stickyStyle: { alignSelf: 'flex-start' },
      // });
    } else if (Math.abs(top) + elmHeight + offset >= contHeight) {
      // Care case container is too short
      if (this.stickyState === 'bottom') return;
      this.stickyElement.style.position = 'initial';
      this.stickyElement.style.top = 0;
      this.stickyElement.style.alignSelf = 'flex-end';
      this.stickyState = 'bottom';
      // this.setState({
      //   stickyState: 'bottom',
      //   // stickyStyle: { alignSelf: 'flex-end' },
      // });
    } else if (this.stickyState !== 'fixed') {
      if (this.stickyState === 'fixed') return;
      this.stickyElement.style.position = 'fixed';
      this.stickyElement.style.width = '333px';
      this.stickyElement.style.top = `${offset}px`;
      this.stickyState = 'fixed';
      // this.setState({
      //   stickyState: 'fixed',
      //   // stickyStyle: { position: 'fixed', width: '333px', top: `${offset}px` },
      // });
    }
  }

  render() {
    const { trip, url, peerReview, sessionData, isWishlisted, /* rates, availability, isSessionDataLoaded, isTripLoading, isLoadingPricing, */ pricing } = this.props;
    // const { currency } = sessionData;
    // const userCountry = (sessionData.userType && sessionData.userType.type) || null;
    const wishlisted = isWishlisted[trip._id] || { state: false, loading: false };
    const isWishListed = wishlisted.state !== wishlisted.loading;
    const quantity = sessionData.quantity > trip.max_travelers ? trip.max_travelers - 1 : sessionData.quantity - 1;
    let ticketPrice = null;
    if (trip.product_type === 'ticket') {
      ticketPrice = Math.min(
        ...trip.multi_tier_prices
          .map(t => t.sub_tiers.reduce(
            (prev, curr) => (prev > curr.price ? curr.price : prev),
            100000000
          ))
      );
    }
    const pricingProps = {
      displayPrice: convert(
        trip.full_prices
          ? trip.full_prices.map(price => price.seasonedDiscountedPerPerson || price.discounted)[quantity]
          : trip.prices[quantity],
        sessionData.currency,
        this.props.rates
      ),
      ticketPrice: ticketPrice
        ? convert(
          ticketPrice,
          sessionData.currency,
          this.props.rates,
        )
        : null,
      currency: sessionData.currency
    };
    const isShowReview = !peerReview && !trip.is_hide_review && trip.review_count > 0;
    // const defaultQuantity = sessionData.quantity;
    // const isChildEnabled = !!trip.additional_options.find(option => option.type === 'child_price');
    let isHideMap = true;
    trip.meeting_points.map(data => { // eslint-disable-line
      if (data.type === 'Hotel Pickup' && trip.meeting_points.length <= 1) {
        isHideMap = false;
      }
    });
    // const useDateDropdown = global.window ? global.window.innerHeight <= 768 : false;
    return (
      <div>
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: xss(JSON.stringify(getJsonLd('getTrip', trip))) }} />
        {/* <Cover
          trip={trip}
          isWishlisted={isWishListed}
          onClickGallery={this.onOpenGallery}
          onClickShare={() => this.props.openShare()}
          onClickWishlist={(e) => this.handleClickWishlist(e, wishlisted.state !== wishlisted.loading)}
        /> */}
        <CoverV2
          trip={trip}
          isWishlisted={isWishListed}
          onClickGallery={this.onOpenGalleryAndGoTo}
          onClickShare={() => this.props.openShare()}
          onClickWishlist={(e) => this.handleClickWishlist(e, wishlisted.state !== wishlisted.loading)}
        />
        <TripDetailContainer>
          <DesktopColumn>
            {(
              (trip.product_type === 'ticket' && !trip.tags.includes('spa'))
              || trip.product_type !== 'ticket'
            ) && (
              <BreadcrumbContainer className={(trip.product_type === 'ticket' && !trip.tags.includes('disallow_thai')) ? '' : 'new-desktop-show'}>
                <Breadcrumbs
                  type="TripDetail"
                  data={trip}
                />
              </BreadcrumbContainer>
            )}
            {((trip.availabilities && trip.availabilities.length > 0)
            || (!trip.is_date_not_required)) && (
              <TripAvailableDays tripDetail={trip} />
            )}
            <Title
              {...pricingProps}
              displayType="a"
              isMasterTrip={trip && trip.is_master_trip}
              trip={trip}
              isWishlisted={isWishListed}
              onClickShare={() => this.props.openShare()}
              onClickWishlist={(e) => this.handleClickWishlist(e, wishlisted.state !== wishlisted.loading)}
            />
            {trip.user_id.is_show_lx_profile && !trip.is_hide_summary && (
              <TripLX
                trip={trip}
                onRequest={(e) => this.props.onRequest(e, 'message', isMobile() ? 'mobile' : 'desktop', this.state)}
                messageLink={this.props.onRequest(null, 'message', isMobile() ? 'mobile' : 'desktop', this.state)}
              />
            )}
            {!trip.is_hide_summary && <TripIntro trip={trip} bookingFee={pricing && pricing.bookingFee} lastCouponState={this.state.showCoupon} customize={this.state.customize} />}
            {trip.is_localtable_trip && (
              (() => {
                const isRestaurant = trip.restaurant_ids.length > 0;
                const isHomeCooking = trip.home_cooking.menus
                  && trip.home_cooking.menus.length > 0
                  && trip.home_cooking.images
                  && trip.home_cooking.images.length > 0;
                if (!isRestaurant && !isHomeCooking) return null;
                return (
                  <LocalTable
                    trip={trip}
                    menus={isRestaurant
                      ? trip.restaurant_ids[0].menus
                      : trip.home_cooking.menus
                    }
                    type={isRestaurant ? 'restaurant' : 'homeCooking'}
                  />
                );
              })()
            )}
            {trip.custom_detail && (
              <TripCustomDetail trip={trip} />
            )}
            {!trip.is_per_day && !trip.is_hide_itinerary && (
              <Fragment>
                {/* <HR /> */}
                {/* <TripSubjects
                  trip={trip}
                  header="itinerary"
                /> */}
                <Itinerary data={trip.itinerary} />
              </Fragment>
            )}
            {trip && trip.is_master_trip && (trip.cover_image || (trip.images && trip.images.length > 0)) && (
              <Fragment>
                <TripCardGallery
                  isVideo={trip.video_url}
                  openGallery={this.onOpenGalleryAndGoTo}
                  dataGallery={[
                    { image: trip.cover_image, caption: trip.cover_image_caption },
                    ...trip.images.filter(image => image.image !== trip.cover_image)
                  ]}
                />
                <HR />
              </Fragment>
            )}
            {/* {trip.conditions && trip.conditions.length > 0 && (
              <Fragment>
                <TripConditions trip={trip} />
              </Fragment>
            )} */}
            {!trip.is_hide_price_condition && (
              <Fragment>
                <PriceCondition trip={trip} />
              </Fragment>
            )}
            {trip.things_to_prepare && trip.things_to_prepare.length > 0 && (
              <Fragment>
                <ThingsToPrepare tripDetail={trip} />
              </Fragment>
            )}
            {/* {!trip.is_hide_faq && (
              <Fragment>
                <TripSubjects
                  trip={trip}
                  header="faqs"
                />
              </Fragment>
            )} */}
            {!trip.is_hide_faq && (trip.faqs || []).length > 0 && (
              <Fragment>
                <HR />
                <FAQ
                  trip={trip}
                />
              </Fragment>
            )}
            {!trip.is_hide_meeting_point && (
              <Fragment>
                <MeetingPointContainer>
                  <MeetingPointDetail>
                    <MeetingPoints trip={trip} />
                  </MeetingPointDetail>
                  {isHideMap && (
                    <MeetingPointMap>
                      <MeetingPointsMap trip={trip} />
                    </MeetingPointMap>
                  )}
                </MeetingPointContainer>
              </Fragment>
            )}
            {!peerReview && !trip.is_hide_review && (
              <div ref="reviewsContainer">
                <Element name="review" />
                <HR />
                {/* <Reviews
                  tripId={trip._id}
                  reviews={trip.reviews}
                  score={trip.rating}
                  categoryScore={trip.review_score}
                  displayCount={this.state.reviewShowCount}
                  lx={trip.user_id}
                  onClickLoadMore={this.loadMoreReview}
                  withoutReviewCount={trip.travelers_without_review}
                  fullPath={url && url.query && url.query.fullPath}
                  userCountry={userCountry}
                  selectedCountry={this.state.selectedCountry}
                  onSelectFilter={this.handleSelectedReviewFilter}
                  responderId={user._id}
                  onReply={this.onReply}
                  onVote={this.onVote}
                  productType={trip.product_type}
                  LXLinkContainer={trip.user_id.slug && <Link to={`/local-expert/${trip.user_id.slug}`}></Link>}
                  renderTripName={tripData => (
                    <ReviewTripName>
                      {tripData.slug === trip.slug
                        ? <a>{tripData.name}</a>
                        : <Link to={`/${tripData.product_type === 'ticket' ? 'ticket' : 'trip'}/${tripData.slug}`}>{tripData.name}</Link>
                      }
                    </ReviewTripName>
                  )}
                  renderGallery={images => (
                    <GalleryReview
                      images={images}
                    />
                  )}
                /> */}
                <Reviews
                  // reviews={trip.reviews}
                  // lxInfo={trip.user_id}
                  // trip={trip}
                  // rating={trip.rating}
                  // categoryScore={trip.review_score}
                  // withoutReview={trip.travelers_without_review}
                  // user={user}
                  url={url}
                  // userCountry={userCountry}
                  // onReply={this.onReply}
                  // onVote={this.onVote}
                />
              </div>
            )}
          </DesktopColumn>
          <InnerCalendar
            className="new-desktop-show"
            ref={c => { this.stickyContainer = c; }}
            id="thisContainer"
          >
            <CalendarSlider
              ref={c => { this.stickyElement = c; }}
              // style={this.state.stickyStyle}
              style={{ alignSelf: 'flex-start' }}
            >
              {!(trip.product_type === 'car_rental' && trip.fixed_quantity !== 1) && (
                <SliderItemTripContainer>
                  <RequestBookV2
                    onChangeCustomize={this.onChangeCustomize}
                    customize={this.state.customize}
                    openCustomizeQty={this.props.openCustomizeQty}
                  />
                </SliderItemTripContainer>
              )}
              {(
                (trip.product_type === 'car_rental' && trip.fixed_quantity !== 1)
              ) && (
                <SliderItemContainer>
                  <PeriodCarRentalRequestBook />
                </SliderItemContainer>
              )}
            </CalendarSlider>
          </InnerCalendar>
        </TripDetailContainer>
        <NoSSR>
          <Container.InnerContainer>
            {(() => {
              const similarTrips = trip.similarTrips || [];
              if (similarTrips.length === 0) return null;
              if (trip.is_similar_hidden) return null;
              if (peerReview) return null;
              return <SimilarTrips {...this.props} />;
            })()}
            {(trip.product_type === 'trip' && trip.specialPriceAttractions && trip.specialPriceAttractions.length > 0)
              && <Topic
                {...this.props}
                key="section-special-price-attractions"
                topic={{
                  contains: 'tickets',
                  name: 'Special Price Attractions',
                  trip_ids: trip.specialPriceAttractions
                }}
              />
            }
            {trip.product_type === 'trip' && (
              <CustomizeContainer>
                <CustomizeBox />
              </CustomizeContainer>
            )}
          </Container.InnerContainer>
        </NoSSR>
        <BookBarContainer>
          <BookBar
            {...pricingProps}
            trip={trip}
            bookButtonContainer={
              <a
                // onClick={e=> (trip.grouped_trips ? this.props.onOpenGroupedModal() : this.props.onRequest(e, 'book', 'mobile', this.state))}
                // href={trip.grouped_trips ? null : this.props.onRequest(null, 'book', 'mobile', this.state)}
                onClick={e=> this.props.onRequest(e, 'book', 'mobile', this.state)}
                href={this.props.onRequest(null, 'book', 'mobile', this.state)}
                rel="noopener noreferrer nofollow"
              />
            }
            messageButtonContainer={
              <a
                {...trip.is_message_disabled && ['ticket', 'souvenir', 'car_rental'].includes(trip.product_type) ? {
                  onClick: goToMessenger,
                } : {
                  onClick: e => this.props.onRequest(e, 'message', 'mobile', this.state),
                  href: this.props.onRequest(null, 'message', 'mobile', this.state)
                }}
                rel="noopener noreferrer nofollow"
              />
            }
            isHideReviewRating={!isShowReview}
          />
        </BookBarContainer>
      </div>
    );
  }
}

export default enhance(Common);
